import Konva from 'konva';
import React, { ReactNode } from 'react';
import { Layer, Rect, Group } from 'react-konva';

import KonvaImage from 'common/components/RewindModal/Konvas/KonvaImage';
import {
  LAYER_WIDTH,
  LAYER_HEIGHT
} from 'common/components/RewindModal/Konvas/constants';
import {
  FLASHBACK_COVER_LOGO_WIDTH,
  FLASHBACK_COVER_LOGO_HEIGHT,
  FLASHBACK_COVER_LOGO_TOP_MARGIN,
  FLASHBACK_COVER_LOGO_OPACITY,
  FLASHBACK_COVER_LOGO_SHADOW_OFFSET_Y,
  FLASHBACK_COVER_LOGO_SHADOW_BLUR,
  ALLOCINE_LOGO_WIDTH,
  ALLOCINE_LOGO_HEIGHT,
  ALLOCINE_LOGO_BOTTOM_MARGIN
} from 'common/components/RewindModal/Konvas/constants';
import {
  IMG_PARTICLES_BACKGROUND,
  IMG_FLASHBACK_COVER_LOGO,
  IMG_ALLOCINE_LOGO
} from 'common/configuration/constants';

type FlashbackLayoutProps = {
  children: ReactNode;
  backgroundColor?: string;
  backgroundOpacity?: number;
  backgroundImage?: string;
  coverLogoWidth?: number;
  coverLogoHeight?: number;
  coverLogoTopMargin?: number;
  coverLogoOpacity?: number;
  allocineLogoWidth?: number;
  allocineLogoHeight?: number;
  allocineLogoBottomMargin?: number;
};

const FlashbackLayout = ({
  children,
  backgroundColor = '#000000',
  backgroundOpacity = 1,
  backgroundImage,
  coverLogoWidth = FLASHBACK_COVER_LOGO_WIDTH,
  coverLogoHeight = FLASHBACK_COVER_LOGO_HEIGHT,
  coverLogoTopMargin = FLASHBACK_COVER_LOGO_TOP_MARGIN,
  coverLogoOpacity = FLASHBACK_COVER_LOGO_OPACITY,
  allocineLogoWidth = ALLOCINE_LOGO_WIDTH,
  allocineLogoHeight = ALLOCINE_LOGO_HEIGHT,
  allocineLogoBottomMargin = ALLOCINE_LOGO_BOTTOM_MARGIN
}: FlashbackLayoutProps) => {
  const coverLogoY = coverLogoTopMargin;
  const allocineY =
    LAYER_HEIGHT - allocineLogoHeight - allocineLogoBottomMargin;
  const finalBackgroundImage = backgroundImage || IMG_PARTICLES_BACKGROUND;

  return (
    <Layer>
      {/* Background */}
      <Rect width={LAYER_WIDTH} height={LAYER_HEIGHT} fill={backgroundColor} />

      {/* Background image */}
      <KonvaImage
        path={finalBackgroundImage}
        isLocal={true}
        x={0}
        y={0}
        width={LAYER_WIDTH}
        height={LAYER_HEIGHT}
        opacity={backgroundOpacity}
      />

      {/* Flashback Cover logo at the top */}
      <KonvaImage
        path={IMG_FLASHBACK_COVER_LOGO}
        isLocal={true}
        x={(LAYER_WIDTH - coverLogoWidth) / 2}
        y={coverLogoY}
        width={coverLogoWidth}
        height={coverLogoHeight}
        opacity={coverLogoOpacity * 0.6}
        shadowColor={'#2C2C2C'}
        shadowOpacity={0.1}
        shadowOffsetX={0}
        shadowOffsetY={FLASHBACK_COVER_LOGO_SHADOW_OFFSET_Y}
        shadowBlur={FLASHBACK_COVER_LOGO_SHADOW_BLUR}
        filters={[Konva.Filters.Grayscale]}
      />

      {/* Custom content (children) */}
      <Group>{children}</Group>

      {/* AlloCiné logo at the bottom */}
      <KonvaImage
        path={IMG_ALLOCINE_LOGO}
        isLocal={true}
        x={(LAYER_WIDTH - allocineLogoWidth) / 2}
        y={allocineY}
        width={allocineLogoWidth}
        height={allocineLogoHeight}
      />
    </Layer>
  );
};

export default FlashbackLayout;
